// ======================================
// Contact Page Module
// ======================================

import { icons } from '../components.js';
import { inquiriesAPI } from '../lib/api.js';

export function renderContactPage() {
  return `
    <section class="section contact-section">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-info">
            <h1 class="contact-title">Let's Create Your Dream Home</h1>
            <p class="contact-desc">
              Ready to transform your space? Get in touch with our design experts 
              for a free consultation. We'll help you bring your vision to life.
            </p>
            
            <div class="contact-methods">
              <div class="contact-method">
                <div class="contact-method-icon">${icons.phone}</div>
                <div>
                  <p class="contact-method-label">Phone</p>
                  <p class="contact-method-value">
                    <a href="tel:+918220595978">+91 82205 95978</a>
                  </p>
                </div>
              </div>
              
              <div class="contact-method">
                <div class="contact-method-icon">${icons.mail}</div>
                <div>
                  <p class="contact-method-label">Email</p>
                  <p class="contact-method-value">
                    <a href="mailto:hello@nammaveetuinteriors.com">hello@nammaveetuinteriors.com</a>
                  </p>
                </div>
              </div>
              
              <div class="contact-method">
                <div class="contact-method-icon">${icons.mapPin}</div>
                <div>
                  <p class="contact-method-label">Experience Center</p>
                  <p class="contact-method-value">
                    123 Design Street, Anna Nagar<br>Chennai - 600040
                  </p>
                </div>
              </div>
              
              <div class="contact-method">
                <div class="contact-method-icon">${icons.clock}</div>
                <div>
                  <p class="contact-method-label">Working Hours</p>
                  <p class="contact-method-value">
                    Mon - Sat: 10:00 AM - 7:00 PM<br>
                    Sunday: By Appointment
                  </p>
                </div>
              </div>
            </div>
            
            <div class="quick-contact">
              <a href="https://wa.me/918220595978?text=Hi, I'm interested in interior design services" 
                 class="quick-contact-btn quick-contact-whatsapp" target="_blank">
                ${icons.messageCircle}
                WhatsApp
              </a>
              <a href="tel:+918220595978" class="quick-contact-btn quick-contact-call">
                ${icons.phone}
                Call Now
              </a>
            </div>
          </div>
          
          <div class="contact-form-card">
            <h2 class="contact-form-title">Get Free Consultation</h2>
            <p class="contact-form-subtitle">Fill the form and we'll call you within 24 hours</p>
            
            <form class="contact-form" id="contact-form">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label" for="contact-name">Full Name *</label>
                  <input type="text" id="contact-name" name="name" class="form-input" 
                         placeholder="Enter your name" required>
                </div>
                <div class="form-group">
                  <label class="form-label" for="contact-phone">Phone Number *</label>
                  <input type="tel" id="contact-phone" name="phone" class="form-input" 
                         placeholder="+91 82205 95978" required>
                </div>
              </div>
              
              <div class="form-group">
                <label class="form-label" for="contact-email">Email Address</label>
                <input type="email" id="contact-email" name="email" class="form-input" 
                       placeholder="your@email.com">
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label" for="contact-property">Property Type</label>
                  <select id="contact-property" name="property" class="form-select">
                    <option value="">Select type</option>
                    <option value="1bhk">1 BHK</option>
                    <option value="2bhk">2 BHK</option>
                    <option value="3bhk">3 BHK</option>
                    <option value="4bhk">4 BHK+</option>
                    <option value="villa">Villa</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label" for="contact-budget">Budget Range</label>
                  <select id="contact-budget" name="budget" class="form-select">
                    <option value="">Select budget</option>
                    <option value="3-5l">₹3-5 Lakhs</option>
                    <option value="5-8l">₹5-8 Lakhs</option>
                    <option value="8-12l">₹8-12 Lakhs</option>
                    <option value="12l+">₹12 Lakhs+</option>
                  </select>
                </div>
              </div>
              
              <div class="form-group">
                <label class="form-label" for="contact-message">Tell us about your project</label>
                <textarea id="contact-message" name="message" class="form-textarea" 
                          placeholder="Describe your requirements, timeline, or any specific preferences..."></textarea>
              </div>
              
              <div id="contact-error" class="form-error" style="display: none;"></div>
              
              <button type="submit" class="btn btn-primary btn-lg contact-submit">
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <section class="map-section">
      <div class="container">
        <div class="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.0080692193045!2d80.20967431482225!3d13.085508090776044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sAnna%20Nagar%2C%20Chennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1640000000000!5m2!1sen!2sin"
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </section>
  `;
}

// Initialize contact form
export function initContactForm() {
  const form = document.getElementById('contact-form');
  const errorDiv = document.getElementById('contact-error');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const submitBtn = form.querySelector('.contact-submit');
    const originalText = submitBtn.innerHTML;

    // Get form data
    const formData = {
      name: form.name.value.trim(),
      phone: form.phone.value.trim(),
      email: form.email.value.trim(),
      property_type: form.property.value,
      budget_range: form.budget.value,
      message: form.message.value.trim(),
      page_source: 'contact'
    };

    // Validate
    if (!formData.name || !formData.phone) {
      showError('Please fill in all required fields');
      return;
    }

    // Show loading state
    submitBtn.innerHTML = '<span class="spinner"></span> Submitting...';
    submitBtn.disabled = true;
    if (errorDiv) errorDiv.style.display = 'none';

    try {
      await inquiriesAPI.create(formData);

      // Show success state
      submitBtn.innerHTML = `${icons.check || '✓'} Request Submitted!`;
      submitBtn.style.backgroundColor = 'var(--color-success, #22c55e)';

      // Reset form after delay
      setTimeout(() => {
        form.reset();
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
        submitBtn.style.backgroundColor = '';
      }, 3000);

    } catch (error) {
      console.error('Contact form error:', error);
      showError(error.message || 'Failed to submit. Please try again.');
      submitBtn.innerHTML = originalText;
      submitBtn.disabled = false;
    }
  });

  function showError(message) {
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
    }
  }
}
